export default function AIPromptsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.5L11.6 6.4L15.5 8L11.6 9.6L10 13.5L8.4 9.6L4.5 8L8.4 6.4L10 2.5Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13L16.2 14.8L18 15.5L16.2 16.2L15.5 18L14.8 16.2L13 15.5L14.8 14.8L15.5 13Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
